export const productsEndpoints = (builder) => ({
    getProductTariffs: builder.query({
        query: (postData) => ({
            url: "",
            params: {
                method_name: "product_tariffs_get",
                ...postData
            },
        }),

        transformResponse: (resp) => resp?.data?.products ?? {},
    }),
});